import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {

  private serverErrorSource = new Subject<string>();
  private sameAppNavClickedSource = new Subject<string>();
  private parentAppNavSelectionRetainSource = new Subject<string>();
  private navigationSource = new Subject<string>();

  serverError$ = this.serverErrorSource.asObservable();
  sameAppNavClickedSource$ = this.sameAppNavClickedSource.asObservable();
  parentAppNavSelectionRetainSource$ = this.parentAppNavSelectionRetainSource.asObservable();
  navigationSource$ = this.navigationSource.asObservable();

  conveyErrorOccurred(error) {
    this.serverErrorSource.next(error);
  }

  conveySameAppNavClicked(id) {
    this.sameAppNavClickedSource.next(id);
  }

  conveyToRetainParentAppNavSelection(id) {
    this.parentAppNavSelectionRetainSource.next(id);
  }

  conveyToNavigate(baseHref) {
    this.navigationSource.next(baseHref);
  }
}
